<vex-base-layout *ngIf="config$ | async as config">
  <vex-progress-bar></vex-progress-bar>

  <vex-search></vex-search>

  <div class="vex-layout-sidenav-container app-shell">
    <div
      (click)="onSidenavClosed()"
      *ngIf="!(isDesktop$ | async) && (sidenavOpen$ | async)"
      class="app-sidenav-backdrop"></div>

    <aside
      [class.app-sidenav-panel--mobile]="!(isDesktop$ | async)"
      [class.app-sidenav-panel--open]="(isDesktop$ | async) || (sidenavOpen$ | async)"
      class="app-sidenav-panel">
      <vex-sidenav [collapsed]="!!(sidenavCollapsed$ | async)"></vex-sidenav>
    </aside>

    <mat-sidenav-container class="app-shell-main">
      <mat-sidenav (closedStart)="onQuickpanelClosed()" [opened]="!!(quickpanelOpen$ | async)"
        class="vex-layout-quickpanel" mode="over" position="end">
        <vex-quickpanel></vex-quickpanel>
      </mat-sidenav>

      <mat-sidenav-content class="app-content-scroll">
        <vex-toolbar [class.dark]="config.layout === 'vertical'" class="vex-toolbar"></vex-toolbar>

        <main class="vex-layout-content">
          <router-outlet></router-outlet>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>

  <vex-config-panel-toggle (openConfig)="configpanel.open()"></vex-config-panel-toggle>

  <!-- CONFIGPANEL -->
  <vex-sidebar #configpanel [invisibleBackdrop]="true" [opened]="!!(configPanelOpen$ | async)" position="right">
    <vex-config-panel></vex-config-panel>
  </vex-sidebar>
  <!-- END CONFIGPANEL -->
</vex-base-layout>